import { SOLID_LINE } from "../../constants"
import styles from "./LineComponent.module.scss"

const LineComponent = (props) => {
  const {
    fill = "none",
    color,
    strokeWidth = 1,
    d,
    lineType = SOLID_LINE,
    clipPath = "",
    dataTestID = ""
  } = props

  return (
    <path
      className={styles[`line${lineType}`]}
      fill={fill}
      stroke={color}
      strokeWidth={strokeWidth}
      d={d}
      clipPath={clipPath}
      data-testid={dataTestID}
    />
  )
}

export default LineComponent
